import { Input, Button, Dropdownlist} from "@qastanfit/qastan-ui"
import styles from "../../styles/components/SearchDossiers.module.scss";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { RootState } from "../../store";
import { useEffect, useRef, useState } from "react";
import { convertArrayToDropdownlist } from "../../functions/convert";
import { setDossiers, setNotification } from "../../redux/actions";
import { useQuery } from "react-query";
import axios from "src/axios/axios";
import useAuth from "src/hooks/useAuth";

type Props = {
    onClose: () => void;
}

const SearchDossiers : React.FC<Props> = ({onClose}) => {
    const dispatch = useAppDispatch()

    const dossiertypes:DossiertypeObject[] = useAppSelector((state:RootState) => state.dossiertypes);
    const {auth} = useAuth()

    const [isSearching, setisSearching] = useState(false);
    const [dossiertypesList, setdossiertypesList] = useState<Array<string>>();
    const [selectedDossiertype, setselectedDossiertype] = useState<string>();

    const searchValue = useRef<string>()

    useEffect(()=>{
        let arr = convertArrayToDropdownlist(dossiertypes, "dossiertypeid", "name")
        setdossiertypesList(arr)
    }, [dossiertypes])
    
    useQuery({
        queryKey: ['dossiers'],
        queryFn: async () => {
            const baseURL = process.env.REACT_APP_SERVER_LINK
            const token = auth.data?.token
            const {data} = await axios.get(`dossiers/get`)
            if(data.errorcode!==0){throw new Error(data.message)}
            dispatch(setDossiers(data.object))
            return data.object
        }
    })

    return (
        <div className={styles.searchdossiers}>
            <div className={styles.header}>
                <p className={styles.title}>Dossiers zoeken</p>
                <button onClick={()=>{onClose()}} className={styles.close}><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>
            </div>

            <div className={styles.body}>
                <div>
                    <p className={styles.label}>Status</p>
                    <div className={styles.ddl}><Dropdownlist disabled onSelect={(v:unknown)=>{}} options={[]} selected={""} placeholder="Status..." type="ID_LABEL" closeOnSelect /></div>
                </div>

                <div>
                    <p className={styles.label}>Type</p>
                    <div className={styles.ddl}><Dropdownlist onSelect={(v:{value:string, label:string})=>{setselectedDossiertype(v.value)}} options={dossiertypesList} selected={""} placeholder="Type..." type="ID_LABEL" closeOnSelect /></div>
                </div>

                <div>
                    <p className={styles.label}>Eigenaar</p>
                    <div className={styles.ddl}><Dropdownlist disabled onSelect={(v:unknown)=>{}} options={[]} selected={""} placeholder="Eigenaar..." type="ID_LABEL" closeOnSelect /></div>
                </div>

                <div>
                    <p className={styles.label}>Zoekterm</p>
                    <Input onChange={(target:HTMLInputElement) => {searchValue.current = (target.value)}} placeholder="Zoekterm..." />
                </div>
                
            </div>

            {/* <div className={styles.footer}>
                <Button disabled={isSearching} isLoading={isSearching} onClick={()=>{handleSearchDossiers()}}>Zoeken</Button>
            </div> */}
            
            
        </div>
    )
}

export default SearchDossiers;